<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap>
                <v-flex sm4>
                    <count-up :endVal="items.length" text="Members who have served in both chambers" />
                </v-flex>
                <v-flex sm4>
                    <count-up :endVal="startedInReps" text="Members who started in the House of Representatives" />
                </v-flex>
                <v-flex sm4>
                    <count-up :endVal="startedInSenate" text="Members who started in the Senate" />
                </v-flex>
            </v-layout>
            <br/>
            <br/>
            <v-data-table
                :headers="headers" 
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :hide-headers="isMobile"
                :loading="loading"
                :disable-initial-sort="true"
                :custom-sort="customSort">
                <template v-slot:items="props">
                    <template v-if="isMobile">
                            <tr>
                                <td>
                                    <div class="flex-content">
                                        <div class="flex-item">
                                            <h3 class="pb-xs-1"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></h3>
                                        </div>
                                        <div class="flex-item flex-item-col flex-item-col-30">
                                            <div class="flex-item">
                                                <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                            </div>
                                        </div>
                                        <div class="flex-item flex-item-col flex-item-col-70">
                                            <div class="flex-item" data-label="House of Representatives">
                                                <div v-for="service in props.item.RepsService" :key="service.$id">{{ service.YearStart }}–{{ service.YearEnd || 'Present' }}</div>
                                            </div>
                                            <div class="flex-item" data-label="Senate">
                                                <div v-for="service in props.item.SenateService" :key="service.$id">{{ service.YearStart }}–{{ service.YearEnd || 'Present' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    <template v-if="!isMobile">
                        <td class="text-xs-left">
                            <Portrait v-bind:fixedWidth="80" v-bind:PHID="props.item.Phid"></Portrait>
                        </td>
                        <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></td>
                        <td class="text-xs-left"><div v-for="service in props.item.RepsService" :key="service.$id">{{ service.YearStart }}–{{ service.YearEnd || 'Present' }}</div></td>
                        <td class="text-xs-left"><div v-for="service in props.item.SenateService" :key="service.$id">{{ service.YearStart }}–{{ service.YearEnd || 'Present' }}</div></td>
                    </template>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>            
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import axios from 'axios';
import Portrait from '@/components/Portrait.vue'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import CountUp from './CountUp.vue';

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        CountUp,
        Portrait,
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const url = `StatisticalInformation/ServedBothChambers`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index === "RepsService" || index === "SenateService") {
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    const aService = a[index][0].YearStart;
                    const bService = b[index][0].YearStart;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items
            .map(i => ({
                Phid: i.Phid,
                Member: i.DisplayName,
                'House of Representatives': i.RepsService.reduce((a, b, i) => i === 0 ? `${b.YearStart}–${b.YearEnd}` : a + `, ${b.YearStart}–${b.YearEnd}`, ''),
                'Senate': i.SenateService.reduce((a, b, i) => i === 0 ? `${b.YearStart}–${b.YearEnd}` : a + `, ${b.YearStart}–${b.YearEnd}`, '')
                }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Members who have served in both chambers';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        } ,
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },             
    },
    mounted() {
        this.onResize();
    },
    computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            startedInReps() {
                return this.items.filter(i => i.RepsService[0].YearStart < i.SenateService[0].YearStart).length
            },
            startedInSenate() {
                return this.items.filter(i => i.SenateService[0].YearStart < i.RepsService[0].YearStart).length
            }
    },    
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        title: 'Members who have served in both chambers',
        isMobile: false,
        headers: [
             {
                text: 'Photo',
                value: 'DisplayName',
                sortable: false,
                width: '100px'
            },
            {
                text: 'Parliamentarian',
                value: 'DisplayName'
            },
            {
                text: 'House of Representatives',
                value: 'RepsService'
            },
            {
                text: 'Senate',
                value: 'SenateService'
            }
        ],
        items: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        memberOrSenator: 'member',
        rowsPerPageItems: [ 10, 25, {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }
</style>